/**
 * Custom Fields: all UI strings for unit/property custom fields pages and sub-components.
 *
 * Keep values in alphabetical order within each group.
 */

export const customFieldsEn = {
  customFields: {
    accountMainWebsiteTitle: 'Account / Main Website Custom Content',
    siteCustomContentTitle: '{name} Custom Content',
    translatingContentTitle: 'Translating Content',
    translatingContentMessage: 'While editing non-English content, some editing features may be hidden / disabled. Empty inputs in non-English content are filled in with English values (if they exist).',
    siteContentInfoMsg: 'Property Custom Content is organized by the site on which it appears.<br>Account level and main website level custom content appears under <strong><i class="far fa-briefcase"></i> Account / Main Website Custom Content</strong>',

    // RsPartialCustomFieldsV2
    cardTitle: 'Custom Fields',
    addCustomField: 'Add Custom Field',
    translationsButtonTooltip: 'An English value must exist before this custom field can be translated. Please save custom field before adding translations.',
    translationMessage: '* An English version is required before adding translation.',
    translationsModalHeader: 'Custom Content - Translations',
    selectPlaceholder: 'Select',
    selectNewFile: 'Select new file',
    newOption: 'New option',

    // Inline form labels
    labelFieldType: 'Field Type',
    labelFieldName: 'Field Name',
    labelKey: 'Key',
    labelDescription: 'Description',
    labelVisibility: 'Visibility',
    labelGlobalScope: 'Global Scope',
    labelHiddenField: 'Hidden Field',
    addOption: 'Add Option',

    // Data table column headers
    columnTitle: 'Title',
    columnKey: 'Key',
    columnValue: 'Value',

    // Field type options
    fieldTypeTextField: 'Text Field',
    fieldTypeTextArea: 'Text Area',
    fieldTypeEditor: 'Rich Text Editor',
    fieldTypeFullEditor: 'Full Text Editor',
    fieldTypeImage: 'Image',
    fieldTypeFile: 'File',
    fieldTypeFeaturedBuilding: 'Featured Building',
    fieldTypeSelect: 'Select Option',
    fieldTypeCheckboxes: 'Checkbox Option',

    // getLabel values
    getLabelUpload: 'Upload',
    getLabelBuilding: 'Building',
    getLabelOptions: 'Options',
    getLabelContent: 'Content',

    // Validation toasts
    validationKeyRequired: 'Key should be filled.',
    validationNoDuplicateKey: 'No key should be duplicated.',
    validationUniqueOptions: 'Options should be unique.',
  },
} as const;

export const customFieldsFr = {
  customFields: {
    accountMainWebsiteTitle: 'Contenu personnalisé du compte ou du site web principal',
    siteCustomContentTitle: 'Contenu personnalisé de {name}',
    translatingContentTitle: 'Traduction du contenu',
    translatingContentMessage: 'Lors de la modification de contenu non anglais, certaines fonctionnalités d\'édition peuvent être masquées ou désactivées. Les champs vides dans le contenu non anglais sont remplis avec les valeurs en anglais (si elles existent).',
    siteContentInfoMsg: 'Le contenu personnalisé de la propriété est organisé par site sur lequel il apparaît.<br>Le contenu personnalisé au niveau du compte et du site web principal apparaît sous <strong><i class="far fa-briefcase"></i> Contenu personnalisé du compte ou du site web principal</strong>',

    // RsPartialCustomFieldsV2
    cardTitle: 'Champs personnalisés',
    addCustomField: 'Ajouter un champ personnalisé',
    translationsButtonTooltip: 'Une valeur en anglais doit exister avant que ce champ personnalisé puisse être traduit. Veuillez enregistrer le champ personnalisé avant d\'ajouter des traductions.',
    translationMessage: '* Une version en anglais est requise avant d\'ajouter une traduction.',
    translationsModalHeader: 'Contenu personnalisé - Traductions',
    selectPlaceholder: 'Sélectionner',
    selectNewFile: 'Sélectionner un nouveau fichier',
    newOption: 'Nouvelle option',

    // Inline form labels
    labelFieldType: 'Type de champ',
    labelFieldName: 'Nom du champ',
    labelKey: 'Clé',
    labelDescription: 'Description',
    labelVisibility: 'Visibilité',
    labelGlobalScope: 'Portée globale',
    labelHiddenField: 'Champ masqué',
    addOption: 'Ajouter une option',

    // Data table column headers
    columnTitle: 'Titre',
    columnKey: 'Clé',
    columnValue: 'Valeur',

    // Field type options
    fieldTypeTextField: 'Champ texte',
    fieldTypeTextArea: 'Zone de texte',
    fieldTypeEditor: 'Éditeur de texte enrichi',
    fieldTypeFullEditor: 'Éditeur de texte complet',
    fieldTypeImage: 'Image',
    fieldTypeFile: 'Fichier',
    fieldTypeFeaturedBuilding: 'Immeuble en vedette',
    fieldTypeSelect: 'Option de sélection',
    fieldTypeCheckboxes: 'Option de case à cocher',

    // getLabel values
    getLabelUpload: 'Téléverser',
    getLabelBuilding: 'Immeuble',
    getLabelOptions: 'Options',
    getLabelContent: 'Contenu',

    // Validation toasts
    validationKeyRequired: 'La clé doit être renseignée.',
    validationNoDuplicateKey: 'Aucune clé ne doit être dupliquée.',
    validationUniqueOptions: 'Les options doivent être uniques.',
  },
} as const;
